'use strict';

angular.module('Services')
    .factory('Location', function ($http, $rootScope, Error, Request, Countries) {
        var sendRequest = function(params, url, callback, errorCallback, aborter) {
            const disableAbort = params.disableAbort;
            delete params.disableAbort;
            Request.get(angular.extend({
                url: url,
                successCallback: callback,
                errorCallback: errorCallback,
                data: params || {},
                params: {
                    cache: true
                }
            }, {disableAbort}));
        };
        return {
            get: function(id, callback, errorCallback) {
                var url = ApiURLs.location.location + id + '/';
                sendRequest(false, url, function(data) {
                    callback(data);
                }, errorCallback);
            },
            Country: function(params, callback, errorCallback, aborter) {
                if(Countries.getAll.length < 1)
                    sendRequest(angular.extend(params,{disableAbort:true}), ApiURLs.location.country, function(data){
                        callback(data);
                        Countries.getAll = [...data];
                    }, errorCallback, aborter);
                else{
                    callback(Countries.getAll);
                }
            },
            City: function(params, callback, errorCallback, aborter) {
                console.log('working fine here');
                console.log(params);
                sendRequest(params, ApiURLs.location.location, function(data) {
                    callback(data.content);
                }, errorCallback, aborter);
            },
            locationEnabled: function(params, callback, errorCallback, aborter) {
                sendRequest(angular.extend({enabled:''},params), ApiURLs.location.location, callback, errorCallback, aborter);
            },
            State: function(countryId, callback, errorCallback, aborter, params) {
                var url = ApiURLs.location.state.replace('{{country}}', countryId);
                sendRequest(params, url, function(data) {
                    callback(data.content);
                }, errorCallback, aborter);
            },
            Address: function(id, callback, errorCallback, aborter) {
                var url = ApiURLs.location.location + id + '/';
                sendRequest(false, url, function(data) {
                    callback(data.content);
                }, errorCallback, aborter);
            },
            AddressBook: function(search, callback, errorCallback, aborter) {
                var url = ApiURLs.address.search + search.company;
                sendRequest(false, url, function(data) {
                    callback(data.content);
                }, errorCallback, aborter);
            },
            ZipCode: function(params, callback, errorCallback, aborter, id) {
                sendRequest(params, ApiURLs.location.location + (id ? '/' + id : ''), callback, errorCallback, aborter);
            },
            Postcode: {
                updateStatus: function(params, successCallback, errorCallback, data) {
                    Request.post({
                        url: ApiURL+ 'address/admin/location',
                        method: 'PUT',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: {
                            enabled: params.status
                        }
                    },data);
                }, 
            },
            getCurrentGeoIp: function (successCallback) {
                successCallback(Request.getGeoIp());
            }
        }
    });

angular.module('Services')
    .factory('ArrayFunc', function(RegExpFunc) {
        return {
            group: function(arr) {
                var newResponse = [];
                var stop = false;
                arr.map(function(item) {
                    for (var k = 0; k < newResponse.length; k++) {
                        if (newResponse[k]['name'] == item['name']) {
                            newResponse[k]['codes'].push(item);
                            stop = true;
                        }
                    }
                    if (!stop) {
                        item.codes = [item];
                        newResponse.push(item);
                    }
                    stop = false;
                });
                return newResponse;
            },
            cache: function(options) {
                return new (function(options) {
                    var cache = [];
                    options = options || {};

                    var sortDataArray = function(a, b) {
                        return a[options.sort.order] > b[options.sort.order] && options.sort.orderBy == 'ASC' ? 1 : -1;
                    };

                    /**
                     *
                     * @param obj
                     * @returns {string}
                     */
                    var toQueryString = function(obj) {
                        var data = [];
                        for (var i in obj) {
                            data.push(i + '=' + obj[i]);
                        }
                        return data.join('&');
                    };

                    /**
                     *
                     * @param requestString
                     * @param response
                     * @param advancedData
                     */
                    this.addRequest = function(requestString, response, advancedData) {
                        if (options.sort) {
                            response = response.sort(sortDataArray);
                        }
                        var adv = toQueryString(advancedData);

                        var searched = cache.filter(function(cacheRequest) {
                            var searchString = cacheRequest['q'];
                            /*var regex = new RegExp('^' + RegExpFunc.toRegExpString(requestString), 'i');
                             return regex.test(searchString) && cacheRequest['advanced'] == adv;*/
                            return (requestString == searchString) && (cacheRequest['advanced'] == adv);
                        });

                        searched.length ? searched.map(function(item) {
                            item['q'] = requestString;
                            item['response'] = response;
                        }) : cache.push({
                            q: requestString,
                            response: response,
                            advanced: adv
                        });
                        return response;
                    };

                    /**
                     *
                     * @param requestString
                     * @returns {Object|boolean}
                     * @param advancedData
                     */
                    this.getResponse = function(requestString, advancedData) {
                        var searched = cache.filter(function(cacheRequest) {
                            var searchString = cacheRequest['q'];
                            /*var regex = new RegExp('^' + RegExpFunc.toRegExpString(requestString), 'i');
                             return regex.test(searchString) && cacheRequest['advanced'] == adv;*/
                            return (requestString == searchString) && (cacheRequest['advanced'] == toQueryString(advancedData));
                        });
                        return searched.length ? searched[0]['response'].filter(function(requestItem) {
                            var regex = new RegExp('^' + RegExpFunc.toRegExpString(requestString), 'i');
                            return regex.test(requestItem[options.field]);
                        }) : false;
                    };
                })(options);
            }
        };
    })
    .factory('RegExpFunc', function() {
        return {
            toRegExpString: function(str) {
                return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
            }
        }
    });




// WEBPACK FOOTER //
// ./js/services/locations.js